
    import {
      getAllMedicalAlerts,
      createMedicalAlert,
      createAllMedicalAlerts,
      updateMedicalAlert,
      deleteMedicalAlert
    } from "@/services/medicalAlert";

    const state = {
      medicalAlerts: [],
      processed: false
    };

    const getters = {
      getMedicalAlerts(state) {
        return state.medicalAlerts;
      },
      medicalAlertProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchMedicalAlerts({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllMedicalAlerts(
              params
            )
              .then(response => {
                commit("SET_MEDICALALERTS", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createMedicalAlert({ commit }, medicalAlert) {
          return new Promise((resolve, reject) => {
            createMedicalAlert(medicalAlert)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllMedicalAlerts({ commit }, medicalAlerts) {
          return new Promise((resolve, reject) => {
            createAllMedicalAlerts(medicalAlerts)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateMedicalAlert({ commit }, medicalAlert) {
          return new Promise((resolve, reject) => {
            updateMedicalAlert(medicalAlert)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteMedicalAlert({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteMedicalAlert(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_MEDICALALERTS(state, data) {
        state.medicalAlerts = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    